// extracted by mini-css-extract-plugin
export default {"container":"KPI_container__vjtPL","loading":"KPI_loading__qpTOH","title":"KPI_title__BmUEo","compare":"KPI_compare__Quu4L","compareIcon":"KPI_compareIcon__4GqUv"};